import { useCallback } from 'react';

import { fg } from '@confluence/feature-gating';

import { preloadDefaultAndSpaceClassificationLevels } from '../preload/preloadDefaultAndSpaceClassificationLevels';
import { preloadOrgDefaultClassificationLevelIdQuery } from '../preload/preloadOrgDefaultClassificationLevelIdQuery';

type UsePreloadClassificationEditorQueriesProps = {
	spaceKey?: string | null;
};

type UsePreloadClassificationEditorQueriesReturn = () => void;

export const usePreloadClassificationEditorQueries = ({
	spaceKey,
}: UsePreloadClassificationEditorQueriesProps): UsePreloadClassificationEditorQueriesReturn => {
	return useCallback(() => {
		if (!spaceKey || !fg('dlp_cc-minimize-classifications-queries')) return;
		preloadDefaultAndSpaceClassificationLevels(spaceKey);
		preloadOrgDefaultClassificationLevelIdQuery();
	}, [spaceKey]);
};
